/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type DocumentStatusResponseDTO = {
    message?: DocumentStatusResponseDTO.message;
    status?: DocumentStatusResponseDTO.status;
};

export namespace DocumentStatusResponseDTO {

    export enum message {
        VERIFIED_SUCCESSFULLY = 'VERIFIED_SUCCESSFULLY',
        PENDING_VERIFICATION = 'PENDING_VERIFICATION',
        GENERAL_ERROR_IN_VERIFICATION = 'GENERAL_ERROR_IN_VERIFICATION',
        EXPIRED_DOCUMENT = 'EXPIRED_DOCUMENT',
        LOW_IMAGE_QUALITY = 'LOW_IMAGE_QUALITY',
        SELFIE_DOCUMENT_PHOTO_MISMATCH = 'SELFIE_DOCUMENT_PHOTO_MISMATCH',
        WRONG_DOCUMENT_TYPE = 'WRONG_DOCUMENT_TYPE',
        UNKNOWN = 'UNKNOWN',
    }

    export enum status {
        PENDING_VERIFICATION = 'PENDING_VERIFICATION',
        VERIFIED_SUCCESSFULLY = 'VERIFIED_SUCCESSFULLY',
        NEEDS_MANUAL_VERIFICATION = 'NEEDS_MANUAL_VERIFICATION',
        ERROR_IN_VERIFICATION = 'ERROR_IN_VERIFICATION',
    }


}

